import React, { useEffect, useState } from 'react'
import { IoMdArrowBack } from "react-icons/io";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import * as Constants from "../../../Constants/index";

const ExtraData = () => {
    const navigate = useNavigate();
    const [data , setData] = useState([]);
    const boxesData = [1,2,3,4,5];
    const token = localStorage.getItem("token");

    const goToPage = () => {
        navigate("/select_Additional");
      };

    useEffect(()=> {
        fecthApi()
    },[])

    const fecthApi = async () => {
        try {
          const res = await axios.get(Constants.baseUrl + "user/distributorList/byBranch?sortBy=name&sortAsc=true&limit=100&page=1",
            {
                        headers: {
                          Authorization: `Bearer ${token}`,
                          "Accept-Language": localStorage.getItem("langauge"),
                          appVersion: Constants.av,
                          platform: Constants.pt,
                          company: Constants.company,
                          program: Constants.program,
                        },
                      }
          )
          console.log(res?.data?.output?.results)
        setData(res?.data?.output?.results)
        } catch (error) {
            console.log(error)
        }
    }
  return (
    <>
          <div className="header">
            <IoMdArrowBack className="back-icon" onClick={()=> navigate("/enrollment_form")}/>
            <h3 className="header-title">Select your Preferred shop</h3>
          </div>
          
          <div className='searchingData'>
            <input type='text' placeholder='Search By Name/Code/Mobile' className='searchByAny'/>
            <button className='findBtn'>Search</button>
          </div>

          <div className='exrtaHeading'>
            <p>Preferred Shop*</p>
          </div>

           <div className='shopsData'>
           {data.length !== 0 ? data.map((item, idx) => (
              <div className="classBoxes" key={item.id}>
                {item?.firmName}
              </div>
            )) : 
            boxesData.map((item, idx) => (
              <div className="classBoxes" key={item.id}>
                Data Not found
              </div>
            ))}

           <button className='blueBtn' onClick={goToPage}>Next</button>
           </div> 
    </>
  )
}

export default ExtraData